"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputCheckboxBoolean = exports.InputCheckbox = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const ServiceLocator_1 = __importDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
class InputCheckboxInner extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.onCheckboxInputChange = this.onCheckboxInputChange.bind(this);
        this.onContainerClick = this.onContainerClick.bind(this);
        this.selectAll = this.selectAll.bind(this);
    }
    onContainerClick(_value, e) {
        e.stopPropagation();
        // this.onCheckboxInputChange({target: {value: value}})
    }
    onCheckboxInputChange(e) {
        e.stopPropagation();
        const values = this.props.value;
        const valueSet = new Set(values);
        let choices = [];
        const isChecked = e.target.checked;
        const checkboxValue = e.target.value;
        // use alt key as a check/uncheck all trigger
        if (ServiceLocator_1.default && ServiceLocator_1.default.keyboardManager && ServiceLocator_1.default.keyboardManager.keyIsPressed('alt')) {
            if (valueSet.has(checkboxValue) && !isChecked) {
                // uncheck all
                choices = [];
            }
            else if (!valueSet.has(checkboxValue) && isChecked) {
                // check all
                const allChoices = this.props.choices.map((choice) => {
                    return choice.value;
                });
                choices = allChoices;
            }
        }
        else if (valueSet.has(checkboxValue) && !isChecked) {
            valueSet.delete(checkboxValue);
            choices = Array.from(valueSet);
        }
        else if (!valueSet.has(checkboxValue) && isChecked) {
            valueSet.add(checkboxValue);
            choices = Array.from(valueSet);
        }
        this.props.onValueChange({ target: { value: choices } });
    }
    onCheckboxClick(e) {
        e.stopPropagation();
    }
    onLabelClick(e) {
        e.stopPropagation();
    }
    selectAll(e, checkAll) {
        e.stopPropagation();
        const choices = checkAll ? this.props.choices.map((choice) => choice.value) : [];
        this.props.onValueChange({ target: { value: choices } });
    }
    render() {
        const values = this.props.value ? this.props.value : this.props.defaultValue ? this.props.defaultValue : [];
        const valueSet = new Set(values);
        const choices = this.props.choices;
        const localePrefix = this.props.localePrefix || 'main';
        const choiceInputs = choices.map((choice) => {
            const strValue = choice.value !== null && choice.value !== undefined ? choice.value.toString() : choice.value;
            const id = `${this.props.id}_${strValue}`;
            const strLabel = choice.label || this.props.t(`${localePrefix}:${choice.value}`) || choice.value;
            const iconPath = choice.iconPath;
            return (react_1.default.createElement("div", { key: id, onClick: (e) => {
                    this.onContainerClick(choice.value, e);
                }, className: `tr__form-input-checkbox-container${valueSet.has(choice.value) ? ' checked' : ''}` },
                react_1.default.createElement("div", { className: "label-input-container" },
                    react_1.default.createElement("input", { type: "checkbox", id: id, name: this.props.id, className: '_input-checkbox', value: strValue, disabled: this.props.disabled === true ? true : false, checked: valueSet.has(choice.value), onChange: this.onCheckboxInputChange, onClick: this.onCheckboxClick }),
                    react_1.default.createElement("label", { htmlFor: id, onClick: this.onLabelClick },
                        iconPath && (react_1.default.createElement("span", null,
                            react_1.default.createElement("img", { src: iconPath, className: "_icon", alt: strLabel }))),
                        react_1.default.createElement("span", null, strLabel)))));
        }, this);
        // separate by columns if needed:
        let columnedChoiceInputs = [];
        if (this.props.columns && this.props.columns > 0) {
            const widgetsByColumn = this.props.columns === 1 ? [choiceInputs] : (0, LodashExtensions_1._chunkify)(choiceInputs, this.props.columns, true);
            for (let i = 0, count = widgetsByColumn.length; i < count; i++) {
                const columnWidgets = widgetsByColumn[i];
                columnedChoiceInputs.push(react_1.default.createElement("div", { className: `tr__form-input-checkbox-group-column${this.props.columns === 1 ? ' no-wrap' : ''}`, key: i }, columnWidgets));
            }
        }
        else {
            columnedChoiceInputs = choiceInputs;
        }
        let selectAllWidget = undefined;
        if (this.props.allowSelectAll && !this.props.disabled) {
            const allChecked = choices.find((choice) => !valueSet.has(choice.value)) === undefined;
            const id = `${this.props.id}_selectAll`;
            selectAllWidget = (react_1.default.createElement("div", { className: "tr__form-input-checkbox-group-column", key: id },
                react_1.default.createElement("div", { className: "label-input-container" },
                    react_1.default.createElement("input", { type: "button", id: id, name: this.props.id, className: '_input-checkbox', value: this.props.t(allChecked ? `${localePrefix}:UnselectAll` : `${localePrefix}:SelectAll`), onClick: (e) => this.selectAll(e, !allChecked) }))));
        }
        return selectAllWidget ? (react_1.default.createElement("div", { className: 'apptr__form-input-container' },
            selectAllWidget,
            react_1.default.createElement("div", { className: 'tr__form-input-checkbox-group-container' }, columnedChoiceInputs))) : (react_1.default.createElement("div", { className: 'tr__form-input-checkbox-group-container' }, columnedChoiceInputs));
    }
}
InputCheckboxInner.defaultProps = {
    defaultValue: [],
    choices: [],
    columns: 1,
    localePrefix: 'main',
    disabled: false,
    allowSelectAll: false
};
exports.InputCheckbox = (0, react_i18next_1.withTranslation)(['main', 'transit'])(InputCheckboxInner);
class InputCheckboxBooleanInner extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.innerValueChange = this.innerValueChange.bind(this);
        this._onValueChange = props.onValueChange;
    }
    innerValueChange(e) {
        if (e.target.value.includes('true')) {
            this._onValueChange({ target: { value: true } });
        }
        else {
            this._onValueChange({ target: { value: false } });
        }
    }
    render() {
        return (react_1.default.createElement(exports.InputCheckbox, { choices: [{ value: 'true', label: this.props.label }], localePrefix: this.props.localePrefix, disabled: this.props.disabled, id: this.props.id, value: this.props.isChecked
                ? ['true']
                : this.props.isChecked !== undefined
                    ? []
                    : this.props.defaultChecked
                        ? ['true']
                        : [], onValueChange: (e) => this.innerValueChange(e) }));
    }
}
InputCheckboxBooleanInner.defaultProps = {
    defaultChecked: false,
    label: 'Yes',
    onValueChange: (_e) => {
        /* nothing to do */
    },
    localePrefix: 'main',
    disabled: false
};
exports.InputCheckboxBoolean = (0, react_i18next_1.withTranslation)('main')(InputCheckboxBooleanInner);
exports.default = exports.InputCheckbox;
//# sourceMappingURL=InputCheckbox.js.map